<template>
  <div>
    <div class="loading-bar" v-if="!message.length">
      <div class="circle1 circle"></div>
      <div class="circle2 circle"></div>
      <div class="circle3 circle"></div>
      <div class="circle4 circle"></div>
      <div class="circle5 circle"></div>
      <div class="circle6 circle"></div>
      <div class="circle7 circle"></div>
      <div class="circle8 circle"></div>
      <div class="circle9 circle"></div>
      <div class="circle10 circle"></div>
      <div class="circle11 circle"></div>
      <div class="circle12 circle"></div>
    </div>
    <article v-else class="message is-danger">
      <div class="message-header">
        <p>BMI Pricing Calculator</p>
      </div>
      <div class="message-body">
        {{message}}
      </div>
    </article>
  </div>
</template>

<style lang="scss">
.loading-bar {
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
}

.loading-bar .circle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.loading-bar .circle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #333;
  border-radius: 100%;
  animation: circleFadeDelay 1.2s infinite ease-in-out both;
}
.loading-bar .circle2 {
  transform: rotate(30deg);
}
.loading-bar .circle3 {
  transform: rotate(60deg);
}
.loading-bar .circle4 {
  transform: rotate(90deg);
}
.loading-bar .circle5 {
  transform: rotate(120deg);
}
.loading-bar .circle6 {
  transform: rotate(150deg);
}
.loading-bar .circle7 {
  transform: rotate(180deg);
}
.loading-bar .circle8 {
  transform: rotate(210deg);
}
.loading-bar .circle9 {
  transform: rotate(240deg);
}
.loading-bar .circle10 {
  transform: rotate(270deg);
}
.loading-bar .circle11 {
  transform: rotate(300deg);
}
.loading-bar .circle12 {
  transform: rotate(330deg);
}
.loading-bar .circle2:before {
  animation-delay: -1.1s;
}
.loading-bar .circle3:before {
  animation-delay: -1s;
}
.loading-bar .circle4:before {
  animation-delay: -0.9s;
}
.loading-bar .circle5:before {
  animation-delay: -0.8s;
}
.loading-bar .circle6:before {
  animation-delay: -0.7s;
}
.loading-bar .circle7:before {
  animation-delay: -0.6s;
}
.loading-bar .circle8:before {
  animation-delay: -0.5s;
}
.loading-bar .circle9:before {
  animation-delay: -0.4s;
}
.loading-bar .circle10:before {
  animation-delay: -0.3s;
}
.loading-bar .circle11:before {
  animation-delay: -0.2s;
}
.loading-bar .circle12:before {
  animation-delay: -0.1s;
}

@-webkit-keyframes circleFadeDelay {
  0%, 39%, 100% { opacity: 0; }
  40% { opacity: 1; }
}

@keyframes circleFadeDelay {
  0%, 39%, 100% { opacity: 0; }
  40% { opacity: 1; }
}
</style>

<script>
export default {
  props: ['message'],
};
</script>
